import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const colsNames =
    searchParams.get('colsNames') ||
    'группа 1,группа 2,группа 3,группа 4,группа 5,группа 6';
  const rowsNames = searchParams.get('rowsNames') || 'А-1,А-2,А-3,Б-1,Б-2,Б-3';

  const cols = colsNames.split(',');
  const rows = rowsNames.split(',');

  return {
    user: searchParams.get('user') || '',
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,
    title: searchParams.get('title'),
    titleFontSize: searchParams.get('titleFontSize') || '4.17',
    cols,
    rows,
    scaleMsg: searchParams.get('scaleMsg')
      ? Number(searchParams.get('scaleMsg'))
      : 2.5,
    msgFontSize: searchParams.get('msgFontSize') || '2',
    // анимация
    animRotateDuration: searchParams.get('animRotateDuration')
      ? Number(searchParams.get('animRotateDuration'))
      : 0.6,
    animMovementDelay: searchParams.get('animMovementDelay')
      ? Number(searchParams.get('animMovementDelay'))
      : 2,
    animMovementDuration: searchParams.get('animMovementDuration')
      ? Number(searchParams.get('animMovementDuration'))
      : 1,
    animGlareDuration: searchParams.get('animGlareDuration')
      ? Number(searchParams.get('animGlareDuration'))
      : 1.6,
  };
};
